// Look-up for Excel PWC colours to Junction colours.
// Some of the source colours come out of Excel simply different from the cell property values...hence the double mappings.
// We should be able to
export const pwcToJunctionTableColours = {
  '#D04A02': 'var(--color-platform-data-vis-1)',
  '#FED8C2': 'var(--color-platform-data-vis-1-80-percent-lighter)',
  '#FED8C4': 'var(--color-platform-data-vis-1-80-percent-lighter)',
  '#FEB087': 'var(--color-platform-data-vis-1-60-percent-lighter)',
  '#FEB188': 'var(--color-platform-data-vis-1-60-percent-lighter)',
  '#FD8A4D': 'var(--color-platform-data-vis-1-40-percent-lighter)',

  '#FFB600': 'var(--color-platform-data-vis-2)',
  '#FFF1CC': 'var(--color-platform-data-vis-2-80-percent-lighter)',
  '#FFF0CC': 'var(--color-platform-data-vis-2-80-percent-lighter)',
  '#FFE399': 'var(--color-platform-data-vis-2-60-percent-lighter)',
  '#FFE299': 'var(--color-platform-data-vis-2-60-percent-lighter)',
  '#FFD566': 'var(--color-platform-data-vis-2-40-percent-lighter)',
  '#FFD366': 'var(--color-platform-data-vis-2-40-percent-lighter)',

  '#E0301E': 'var(--color-platform-data-vis-3)',
  '#F9D7D2': 'var(--color-platform-data-vis-3-80-percent-lighter)',
  '#F9D5D2': 'var(--color-platform-data-vis-3-80-percent-lighter)',
  '#F3ACA5': 'var(--color-platform-data-vis-3-60-percent-lighter)',
  '#ED8478': 'var(--color-platform-data-vis-3-40-percent-lighter)',
  '#ED8278': 'var(--color-platform-data-vis-3-40-percent-lighter)',

  '#EB8C00': 'var(--color-platform-data-vis-4)',
  '#FFE9C8': 'var(--color-platform-data-vis-4-80-percent-lighter)',
  '#FFD291': 'var(--color-platform-data-vis-4-60-percent-lighter)',
  '#FFD391': 'var(--color-platform-data-vis-4-60-percent-lighter)',
  '#FFBD59': 'var(--color-platform-data-vis-4-40-percent-lighter)',
  '#FFBC5A': 'var(--color-platform-data-vis-4-40-percent-lighter)',

  '#DB536A': 'var(--color-platform-data-vis-5)',
  '#F8DCE1': 'var(--color-platform-data-vis-5-80-percent-lighter)',
  '#F8DDE1': 'var(--color-platform-data-vis-5-80-percent-lighter)',
  '#F0B9C2': 'var(--color-platform-data-vis-5-60-percent-lighter)',
  '#F1BAC3': 'var(--color-platform-data-vis-5-60-percent-lighter)',
  '#EA97A6': 'var(--color-platform-data-vis-5-40-percent-lighter)',
  '#E998A6': 'var(--color-platform-data-vis-5-40-percent-lighter)',

  '#464646': 'var(--color-platform-data-vis-6)',
  '#DADADA': 'var(--color-platform-data-vis-6-80-percent-lighter)',
  '#B5B5B5': 'var(--color-platform-data-vis-6-60-percent-lighter)',
  '#8F8F8F': 'var(--color-platform-data-vis-6-40-percent-lighter)',
  '#909090': 'var(--color-platform-data-vis-6-40-percent-lighter)',
  '#FCD4B6': 'var(--named-range-color-forecast)',
  '#E8E6DF': 'var(--named-range-color-highlight)',
  'background:#000000': 'background:none',
  windowtext: 'var(--text-primary)',
  '#000000': 'var(--text-primary)',
  '#0089EB': 'var(--color-platform-data-vis-1)',
};

export const pwcToJunctionTableDarkModeColours = {
  ...pwcToJunctionTableColours,
};

export const pwcToJunctionChartColours = {
  '#D04A02': 'var(--accent-1)',
  '#CD4700': 'var(--accent-1)',
  '#FED8C2': 'var(--accent-1-80-percent-lighter)',
  '#FFD8C3': 'var(--accent-1-80-percent-lighter)',
  '#FEB087': 'var(--accent-1-60-percent-lighter)',
  '#FEB288': 'var(--accent-1-60-percent-lighter)',
  '#FD8A4D': 'var(--accent-1-40-percent-lighter)',
  '#FE8A4C': 'var(--accent-1-40-percent-lighter)',
  '#9B3702': 'var(--accent-1-25-percent-darker)',
  '#9C3801': 'var(--accent-1-25-percent-darker)',
  '#672501': 'var(--accent-1-50-percent-darker)',
  '#682501': 'var(--accent-1-50-percent-darker)',
  // Accent-2 colours are the same in Jct as in Excel - currently
  // '#FFB600': 'var(--accent-2)',
  '#F9B200': 'var(--accent-2)',
  // '#FFF1CC': 'var(--accent-2-80-percent-lighter)',
  // '#FFF0CC': 'var(--accent-2-80-percent-lighter)',
  // '#FFE399': 'var(--accent-2-60-percent-lighter)',
  // '#FFE299': 'var(--accent-2-60-percent-lighter)',
  // '#FFD566': 'var(--accent-2-40-percent-lighter)',
  // '#FFD366': 'var(--accent-2-40-percent-lighter)',
  // '#BF8B00': 'var(--accent-2-25-percent-darker)',
  // '#BF8900': 'var(--accent-2-25-percent-darker)',
  // '#805C00': 'var(--accent-2-50-percent-darker)',
  // '#805B00': 'var(--accent-2-50-percent-darker)',

  '#E0301E': 'var(--accent-3)',
  '#E02B18': 'var(--accent-3)',
  '#F9D7D2': 'var(--accent-3-80-percent-lighter)',
  '#F9D6D2': 'var(--accent-3-80-percent-lighter)',
  '#F3ACA5': 'var(--accent-3-60-percent-lighter)',
  '#E7584A': 'var(--accent-3-60-percent-lighter)',
  '#ED8478': 'var(--accent-3-40-percent-lighter)',
  '#ED8277': 'var(--accent-3-40-percent-lighter)',
  '#EB7D71': 'var(--accent-3-40-percent-lighter)',
  '#A92516': 'var(--accent-3-25-percent-darker)',
  '#A82417': 'var(--accent-3-25-percent-darker)',
  '#71180F': 'var(--accent-3-50-percent-darker)',
  '#70180F': 'var(--accent-3-50-percent-darker)',

  '#EB8C00': 'var(--accent-4)',
  '#FFE9C8': 'var(--accent-4-80-percent-lighter)',
  '#FFD291': 'var(--accent-4-60-percent-lighter)',
  '#FFD391': 'var(--accent-4-60-percent-lighter)',
  '#FFBD59': 'var(--accent-4-40-percent-lighter)',
  '#FFBC5A': 'var(--accent-4-40-percent-lighter)',
  '#B06A00': 'var(--accent-4-25-percent-darker)',
  '#B06900': 'var(--accent-4-25-percent-darker)',
  '#754600': 'var(--accent-4-50-percent-darker)',
  '#764600': 'var(--accent-4-50-percent-darker)',

  '#DB536A': 'var(--accent-5)',
  '#F8DCE1': 'var(--accent-5-80-percent-lighter)',
  '#F0B9C2': 'var(--accent-5-60-percent-lighter)',
  '#F1BAC3': 'var(--accent-5-60-percent-lighter)',
  '#E27688': 'var(--accent-5-60-percent-lighter)',
  '#EA97A6': 'var(--accent-5-40-percent-lighter)',
  '#EA97A5': 'var(--accent-5-40-percent-lighter)',
  '#E792A0': 'var(--accent-5-40-percent-lighter)',
  '#BA2741': 'var(--accent-5-25-percent-darker)',
  '#BB2740': 'var(--accent-5-25-percent-darker)',
  '#7C1B2C': 'var(--accent-5-50-percent-darker)',
  '#7D1A2B': 'var(--accent-5-50-percent-darker)',

  '#464646': 'var(--accent-6)',
  '#DADADA': 'var(--accent-6-80-percent-lighter)',
  '#B5B5B5': 'var(--accent-6-60-percent-lighter)',
  '#8F8F8F': 'var(--accent-6-40-percent-lighter)',
  '#909090': 'var(--accent-6-40-percent-lighter)',
  '#343434': 'var(--accent-6-25-percent-darker)',
  '#353535': 'var(--accent-6-25-percent-darker)',
  '#232323': 'var(--accent-6-50-percent-darker)',
  // ===> Line chart <===
  '#0089EB': 'var(--accent-1)',
  '#7B2B00': 'var(--accent-1-25-percent-darker)',
  '#FC5F0B': 'var(--accent-1-60-percent-lighter)',
  '#A43800': 'var(--accent-1-80-percent-lighter)',
  '#FC8646': 'var(--accent-1-40-percent-lighter)',
  '#672400': 'var(--accent-1-40-percent-lighter)',

  '#FFB600': 'var(--accent-2)',
  '#956A00': 'var(--accent-2-25-percent-darker)',
  '#FEC32D': 'var(--accent-2-60-percent-lighter)',
  '#C78F00': 'var(--accent-2-80-percent-lighter)',
  '#FDD060': 'var(--accent-2-40-percent-lighter)',
  '#7D5900': 'var(--accent-2-40-percent-lighter)',

  '#D93854': 'var(--accent-3)',
  '#861A0E': 'var(--accent-3-25-percent-darker)',
  '#E65344': 'var(--accent-3-60-percent-lighter)',
  '#B32213': 'var(--accent-3-80-percent-lighter)',
  '#EA7D72': 'var(--accent-3-40-percent-lighter)',
  '#6F150C': 'var(--accent-3-40-percent-lighter)',

  '#E68900': 'var(--accent-4)',
  '#8A5200': 'var(--accent-4-25-percent-darker)',
  '#FEA31D': 'var(--accent-4-60-percent-lighter)',
  '#B86D00': 'var(--accent-4-80-percent-lighter)',
  '#FDB954': 'var(--accent-4-40-percent-lighter)',
  '#734400': 'var(--accent-4-40-percent-lighter)',

  '#D94E65': 'var(--accent-5)',
  '#961B30': 'var(--accent-5-25-percent-darker)',
  '#E07083': 'var(--accent-5-60-percent-lighter)',
  '#C72540': 'var(--accent-5-80-percent-lighter)',
  '#E692A0': 'var(--accent-5-40-percent-lighter)',
  '#7C1728': 'var(--accent-5-40-percent-lighter)',

  '#444444': 'var(--accent-6)',
  '#292929': 'var(--accent-6-25-percent-darker)',
  '#686868': 'var(--accent-6-60-percent-lighter)',
  '#373737': 'var(--accent-6-80-percent-lighter)',
  '#8D8D8D': 'var(--accent-6-40-percent-lighter)',
  '#222222': 'var(--accent-6-40-percent-lighter)',
  // ===> END Line Chart <===
  // ===> Other Chart <===
  '#7D2C01': 'var(--accent-1-25-percent-darker)',
  '#FD6411': 'var(--accent-1-60-percent-lighter)',
  '#A63B02': 'var(--accent-1-80-percent-lighter)',

  '#996D00': 'var(--accent-2-25-percent-darker)',
  '#FFC533': 'var(--accent-2-60-percent-lighter)',
  '#CC9200': 'var(--accent-2-80-percent-lighter)',
  '#FFD366': 'var(--accent-2-40-percent-lighter)',
  '#7F5B00': 'var(--accent-2-40-percent-lighter)',

  '#861D12': 'var(--accent-3-25-percent-darker)',
  '#B32618': 'var(--accent-3-80-percent-lighter)',
  '#ED8278': 'var(--accent-3-40-percent-lighter)',

  '#8D5400': 'var(--accent-4-25-percent-darker)',
  '#BC7000': 'var(--accent-4-80-percent-lighter)',

  '#961F33': 'var(--accent-5-25-percent-darker)',
  '#E27588': 'var(--accent-5-60-percent-lighter)',
  '#C82A45': 'var(--accent-5-80-percent-lighter)',

  '#2A2A2A': 'var(--accent-6-25-percent-darker)',
  '#6B6B6B': 'var(--accent-6-60-percent-lighter)',
  '#383838': 'var(--accent-6-80-percent-lighter)',
  // ===> END Other Chart <===
};
